<template>
  <section class="confirmPetition">
    <h1>You have successfully confirmed your petition signature</h1>
    <a href="https://peopleoverprof.it/" style="color: black">Return to Homepage</a>

    <loader class="imageLoader" :loading="loading" />
  </section>
</template>

<script>
import HTTP from '@/http-common.js'

import Loader from '@/components/partials/Loader.vue'
export default {
  name: 'RegisterInvite',
  components: {
    Loader,
  },
  data() {
    return {
      loading: false,
    }
  },
  created() {
    this.loading = true
    HTTP.post(`confirm_petition/${this.$route.params.token}`)
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  },
}
</script>

<style>
.confirmPetition {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
}
</style>
